/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Platform API
 * OpenAPI spec version: 1.0.0
 */

export type EntityFieldDefinitionSemanticType = typeof EntityFieldDefinitionSemanticType[keyof typeof EntityFieldDefinitionSemanticType];


export const EntityFieldDefinitionSemanticType = {
  basis_points: 'basis_points',
  boolean_enabled_disabled: 'boolean_enabled_disabled',
  boolean_yes_no: 'boolean_yes_no',
  country_code: 'country_code',
  credit_rating: 'credit_rating',
  duration_days: 'duration_days',
  duration_years: 'duration_years',
  factor: 'factor',
  identifier: 'identifier',
  iso_currency: 'iso_currency',
  money: 'money',
  percentage: 'percentage',
  percentage_fraction: 'percentage_fraction',
  price: 'price',
  quantity: 'quantity',
  score: 'score',
  string_caps_lock_case: 'string_caps_lock_case',
  string_pascal_case: 'string_pascal_case',
  string_sentence_case: 'string_sentence_case',
  time_remaining: 'time_remaining',
  yield: 'yield',
} as const;
